import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../assets/styles/Category.css";
import { BaseUrl } from "../config/api";
import defaultSareeImage from "../assets/images/saree-category.png";
import { toHttps } from "../utils/imageUtils";

const SareeCategory = () => {
  const [sareeCategories, setSareeCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        // Fetch categories
        const categoryResponse = await fetch(`${BaseUrl}/categories/allcategory`);
        if (!categoryResponse.ok) {
          console.error("Failed to fetch categories:", categoryResponse.status);
          return;
        }
        const categoryData = await categoryResponse.json();

        // Fetch all products
        const productsResponse = await fetch(`${BaseUrl}/products/getallproducts`);
        if (!productsResponse.ok) {
          console.error("Failed to fetch products:", productsResponse.status);
          return;
        }
        const productsData = await productsResponse.json();

        // Validate that we received arrays
        if (!Array.isArray(categoryData) || !Array.isArray(productsData)) {
          console.error("Invalid data format received");
          return;
        }

        // Filter and map categories, including only those with available products
        const filteredCategories = categoryData
          .filter((category) => {
            // Check if category is a Saree category and not deleted
            if (category.categoryTypeName?.toLowerCase() !== "saree" || category.isDeleted) {
              return false;
            }

            // Count available products in this category
            const availableProductsCount = productsData.filter(product =>
              !product.isDeleted &&
              product.categoryName === category.categoryName &&
              product.stock > 0 &&
              !product.outOfStock
            ).length;

            // Only include category if it has available products
            return availableProductsCount > 0;
          })
          .map((category) => ({
            name: category.categoryName.toUpperCase(),
            image: toHttps(category.categotyImage) || defaultSareeImage,
            textColor: "white",
            path: category.categoryName.toLowerCase().replace(/\s+/g, "-"),
          }));

        setSareeCategories(filteredCategories);
      } catch (error) {
        console.error("Error fetching saree categories:", error);
      }
    };

    fetchCategories();
  }, []);

  return (
    <>
      {sareeCategories.length > 0 && (
        <div className="saree-category-section">
          <h2 className="category-title">Sarees Category</h2>
          <div className="saree-category-grid">
            {sareeCategories.map((category, index) => (
              <Link
                to={`/category/${category.path}`}
                key={index}
                className="saree-category-card"
              >
                <div className="category-image-container">
                  <img
                    src={category.image}
                    alt={category.name}
                    onError={(e) => {
                      e.target.src = defaultSareeImage;
                    }}
                  />
                  <div className="category-text-overlay">
                    <h3 style={{ color: category.textColor }}>
                      {category.name}
                    </h3>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default SareeCategory;
